import React from 'react';
import { Alert, Typography, Box } from '@mui/material';
import Section from '../../../layout/Section';
import PValueChart from '../../../charts/PValueChart';
import { Ertragsprognose, AktiverErtragswert } from '../../../../types';

interface YieldsSectionProps {
  activeYieldForecast: Ertragsprognose | null;
  /** Der aktuell ausgewählte Ertragswert (Bruttoertrag, P50, P75, P90) */
  activePValue?: AktiverErtragswert;
  /** Callback wenn ein Ertragswert ausgewählt wird */
  onPValueSelect?: (pValue: AktiverErtragswert) => void;
}

const YieldsSection: React.FC<YieldsSectionProps> = ({
  activeYieldForecast,
  activePValue,
  onPValueSelect,
}) => {
  const bruttoertragKWh = activeYieldForecast?.bruttoertrag || 0;
  const nettoertragKWhP50 = activeYieldForecast?.nettoertrag_p50;
  const nettoertragKWhP75 = activeYieldForecast?.nettoertrag_p75;
  const nettoertragKWhP90 = activeYieldForecast?.nettoertrag_p90;

  const handleBarClick = (pValue: string) => {
    // Typumwandlung: Der PValueChart gibt den Label-String zurück
    const validPValues: AktiverErtragswert[] = ['Bruttoertrag', 'P50', 'P75', 'P90'];
    if (validPValues.includes(pValue as AktiverErtragswert)) {
      onPValueSelect?.(pValue as AktiverErtragswert);
    }
  };

  return (
    <Section title="Jahreserträge">
      {activeYieldForecast ? (
        <Box>
          <PValueChart
            bruttoertrag={bruttoertragKWh}
            p50={nettoertragKWhP50}
            p75={nettoertragKWhP75}
            p90={nettoertragKWhP90}
            height="350px"
            activePValue={activePValue}
            onBarClick={onPValueSelect ? handleBarClick : undefined}
          />
          {onPValueSelect && (
            <Typography
              variant="caption"
              sx={{
                color: "text.secondary",
                mt: 1,
                display: 'block',
                textAlign: 'center'
              }}>
              Klicke auf einen Balken, um diesen Ertragswert für die Berechnungen zu verwenden
            </Typography>
          )}
        </Box>
      ) : (
        <Alert severity="info">
          Keine aktive Ertragsprognose verfügbar. Bitte erstellen Sie eine neue Ertragsprognose.
        </Alert>
      )}
    </Section>
  );
};

export default YieldsSection;

